import { getUserDetails } from "../../DoctorMangement/Helper/utils";
import { FORM_NAMES_KEY, INCLINIC, OFFLINE } from "../constant";
import { getRoles } from "./API";
import { ToastEmitter } from "../../DoctorMangement/ToastEmitter";
import {  getUserDetailsFromAccessToken } from "../../../helper/utils"
import { SESSION_STORAGE_KEYS } from "../../../constants/provider/constant";
export const getUrlForSPOCProfilePage = (id, userName=null) => {
    return `/SPOC/SPOCManagements?id=${id}&userName=${encodeURIComponent(userName)}`;
  }


  export const getEntityList = () => {
    const userDetails = getUserDetails()
    let entityArray = [];
    if (userDetails?.parentProvider?.isParent) {
      let childEntity = userDetails.parentProvider.childEntitiesWithEntityId
      const locationsArray = Object.values(childEntity);
      const masterEntityName = userDetails?.entityName + ' (Master Provider)';
      entityArray = [masterEntityName, ...locationsArray];
    }
    else {
      entityArray = [userDetails?.entityName];
    }
    return entityArray
  }

  export const getEntityNameMapping = () => {
    const userDetails = getUserDetails()
    const mapping = {};
  
    if (userDetails.parentProvider.isParent) {
      let childEntity = userDetails.parentProvider.childEntitiesWithEntityId
      for (const [id, fullName] of Object.entries(childEntity)) {
        const locationName = fullName;
        mapping[locationName] = id;
        const masterEntityName = userDetails?.entityName + ' (Master Provider)';
        mapping[masterEntityName] = userDetails?.entityId;
      }
    }
    else {
      mapping[userDetails.entityName] = userDetails.entityId;
    }
    return mapping
  }


  export const getEntityIdMapping = () => {
    const userDetails = getUserDetails()
    const mapping = {};
  
    if (userDetails.parentProvider.isParent) {
      let childEntity = userDetails.parentProvider.childEntitiesWithEntityId
      for (const [id, fullName] of Object.entries(childEntity)) {
        const entityName = fullName;
        const masterEntityName = userDetails?.entityName + ' (Master Provider)';
        mapping[userDetails?.entityId] = masterEntityName;
        mapping[id] = entityName;
      }
    }
    else {
      mapping[  userDetails.entityId] =userDetails.entityName;
    }
    return mapping
  }


  const getRolesForSPOC = async () => {
    const SPOCRolesArray = await getRoles();
    const rolesArray = SPOCRolesArray?.roles?.map((role) => {
        return {
          id: role.id,
          RoleName: role.name,

        }
    })
    if(rolesArray.length > 0) return rolesArray
    else return null;
  }


  const formatRoleNameAndLabel = (role)=>{
    let roleName ='';
    let roleLabel =''
    const roleNameSplit = role.RoleName.split("/*/");
    const specialityMap = JSON.parse(localStorage.getItem(SESSION_STORAGE_KEYS.SPECIALITY_ARRAY) || '{}');
    if(!(roleNameSplit.length>1)) return {roleName, roleLabel};
    const roleDeptLabel = roleNameSplit[0].split('/');
    if(!(roleDeptLabel.length>1)) return {roleName:roleNameSplit[1], roleLabel: roleNameSplit[0].replaceAll('_', ' ')}; 
     roleName = roleNameSplit[1];
     roleLabel = roleDeptLabel[1].replaceAll('_', ' ');
     
     //check if there is label based on labelId if yes pass  the label 
     //from the specilaityMap
     if(roleLabel.includes('^')){
      roleLabel = roleLabel.split('^')[1];
     }

     if(specialityMap[roleLabel]){
        roleLabel = specialityMap[roleLabel];
     }

    return {roleName, roleLabel};
  }

  export const rolesArray = async ()=>{
    try {
      const resp = await getRolesForSPOC()

      const rolesMapAdmin = {};
      const rolesMapEditor ={};
      const rolesMapViewer = {};
      const rolesMapServices = {};
  
      //admin roles
      resp?.map((role) => {
        const {roleName, roleLabel} = formatRoleNameAndLabel(role);
        if(roleName.toLowerCase() == 'admin'){
          rolesMapAdmin[roleLabel]=role.id;
        }
        if(roleName.toLowerCase() == 'editor'){
          rolesMapEditor[roleLabel]=role.id;
        }
        if(roleName.toLowerCase() == 'viewer'){
          rolesMapViewer[roleLabel]=role.id;
        }
        if(roleName.toLowerCase() == 'services'){
          rolesMapServices[roleLabel]=role.id;
        }
      });
  
      return { "admin":rolesMapAdmin, "editor":rolesMapEditor, "viewer":rolesMapViewer, 'services':rolesMapServices}
    }

    catch (error) {
      console.log("Error in the function rolesArray", error);
      throw error;
    }

  }


export const getRolesIdForSelectedRoles = async (formValues) => {
  try {

    //for OFC speciality 
    const selectedOFCSpeciality = formValues?.OFCspecicality?.map((item) => {
      return item?.value
    })

    //for Labs Specicality
    const selectedLabsSpecicality = formValues?.labsSpecicality?.map((item) => {
      return item.value;
    })

    //for services Lab and OFC
    const selectedServices = [];
    if (formValues[FORM_NAMES_KEY.LABS_ACTIVE]) {
      selectedServices.push(FORM_NAMES_KEY.LABS_SERVICE);
    }

    if (formValues[FORM_NAMES_KEY.OPD_ACTIVE]) {
      selectedServices.push(FORM_NAMES_KEY.OPD_SERVICE);
    }


    const roles = await rolesArray();
    const accessLevel = formValues.accessLevel;
    const userRoles = [];

    if (formValues[FORM_NAMES_KEY.VISION_ACTIVE]) {
      selectedServices.push(FORM_NAMES_KEY.VISION_SERVICE);
      const accessRoles = roles[accessLevel];
      const accessSpeciality = accessRoles[FORM_NAMES_KEY.VISION_SPECIALITY];
      if (accessSpeciality)
        userRoles.push(accessSpeciality)
    }

    //for Offline Consults Roles
    for (let index in selectedOFCSpeciality) {
      const speciality = selectedOFCSpeciality[index];
      const accessRoles = roles[accessLevel];
      const accessSpeciality = accessRoles[speciality];
      if (accessSpeciality)
        userRoles.push(accessSpeciality)
    }

    //for Labs Departments
    for (let index in selectedLabsSpecicality) {
      const department = selectedLabsSpecicality[index];
      const accessRole = roles[accessLevel];
      const accessDepartment = accessRole[department];
      if (accessDepartment) {
        userRoles.push(accessDepartment);
      }
    }

    //for Services
    for (let index in selectedServices) {
      const service = selectedServices[index];
      const servicesRole = roles.services
      const accessRole = servicesRole[service];
      if (accessRole) {
        userRoles.push(accessRole);
      }
    }

    return userRoles
  }
  catch (err) {
    console.log("Error in function in getRolesIdForSelectedRoles", err);
    ToastEmitter("Unable to get roles for SPOC", 'error');
    throw err;
  }
}

export const getFeaturesForUser = async (history) => {
  const userDetailsResp = await getUserDetailsFromAccessToken();
  if (userDetailsResp) {
    const userFeature = userDetailsResp?.features?.map((item) => {
      return item.featureName;
    })
    const userRoles = userDetailsResp?.roles
    return {userFeature,userRoles };
  }
  localStorage.clear();
  history.push("/login");
  return [];
}


export const getServiceFilter  = (serviceFilterArray) => {
  const activeServicesFilter = serviceFilterArray.map((val) => {
    if (val == INCLINIC) return OFFLINE;
    else return val; });
    return activeServicesFilter
}

  